// ----------------------------------------------------------------------

const account = {
  displayName: 'Jaydon Frankie',
  email: 'demo@minimals.cc',
  // photoURL: '/assets/images/avatars/user_avatar2.png',
};

export default account;
